import sprintf from 'sprintf';

function timeFilter() {
    'ngInject';

    return v => sprintf('%02d:%02d', Math.floor(v / 60), v % 60);
}

angular
    .module('BB')
    .filter('time', timeFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/time.filter.js